import react from "react";
import React, { useRef, useEffect, useState } from "react";
import QuestionButton from "./QuestionButton";

function HoverInfo({ info }) {
  return (
    <div
      style={{
        // position: "absolute",
        backgroundColor: "white",
        color: "black",
        padding: "6px 10px",
        borderRadius: "6px",
        whiteSpace: "nowrap",

        // zIndex: 2,
      }}
    >
      <p 
      style={{borderBottom:'1px solid black',paddingBottom:'5px',marginBottom:'8px',fontWeight:'bold'}}
      >
      {info.name}
      </p>
          <div>
      {info.data.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "4px",
            // width: "200px",
          }}
        >
          <QuestionButton type={item.type} number={item.number} />
          <p
            style={{
              marginLeft: "8px",
              // wordWrap: "break-word",
              width:'100%'
            }}
          >
            {item.name}
          </p> 
        </div>
      ))}
    </div>

    </div>
  );
}

export default HoverInfo;
